import React from 'react';
import { ModuleBase, Stack, Text, Link, Box } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';
import classNames from 'classnames';

const ResourcesNewsletter = (data: SideBySideModuleModel) => {
  const {
    props: { alignment, link1, title, preTitle, description },
  } = data;

  return (
    <ModuleBase
      data={{ ...data, props: { ...data.props, backgroundColour: '#305545' } }}
      className="ResourcesNewsletter overflow-hidden"
    >
      <Stack
        className={classNames(
          'container flex flex-col justify-between gap-10 lg:mb-10 lg:gap-0',
          alignment === 'Right' ? 'lg:flex-row-reverse' : 'lg:flex-row',
        )}
      >
        <div className="color-from-bg h-full w-full lg:w-1/2 lg:pr-20">
          <Text className="text-style-tag uppercase">{preTitle}</Text>
          {title && (
            <Text
              className="text-style-h2 mt-6 xl:!text-[75px] xl:leading-[75px]"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
          {link1 && (
            <Link
              animate
              className="btn primary !bg-yellow !border-yellow v2 mt-10 !text-[#305545] hover:!border-white hover:!bg-transparent hover:!text-white lg:mt-14"
              link={link1}
            />
          )}
        </div>
        <div className="color-from-bg relative w-full flex-grow overflow-hidden lg:mt-[51px] lg:w-1/2 lg:overflow-visible">
          <Box className="after-extended-line-top pt-10">
            <div
              className="text-style-h4 color-from-bg lg:text-[36px] lg:leading-[45px]"
              dangerouslySetInnerHTML={{ __html: description || '' }}
            />
          </Box>
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default ResourcesNewsletter;
